// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TreeRouteImport } from './routes/tree'
import { Route as TimetableRouteImport } from './routes/timetable'
import { Route as MapRouteImport } from './routes/map'
import { Route as DegreeRouteImport } from './routes/degree'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PIdRouteImport } from './routes/p.$id'

const TreeRoute = TreeRouteImport.update({
            id: '/tree',path: '/tree',getParentRoute: () => rootRouteImport
          })
const TimetableRoute = TimetableRouteImport.update({
            id: '/timetable',path: '/timetable',getParentRoute: () => rootRouteImport
          })
const MapRoute = MapRouteImport.update({
            id: '/map',path: '/map',getParentRoute: () => rootRouteImport
          })
const DegreeRoute = DegreeRouteImport.update({
            id: '/degree',path: '/degree',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const PIdRoute = PIdRouteImport.update({
            id: '/p/$id',path: '/p/$id',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,DegreeRoute: DegreeRoute,MapRoute: MapRoute,TimetableRoute: TimetableRoute,TreeRoute: TreeRoute,PIdRoute: PIdRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)